export enum AppType {
  SCROLL_STATIC = 'SCROLL_STATIC',
  STATIC = 'STATIC',
  BOL = 'BOL',
  WORKFLOW = 'WORKFLOW',
  LINK = 'LINK'
}
